import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  fieldsContainer: {
    position: 'sticky',
    top: '0',
    display: 'flex',
    flexDirection: 'column',
    marginRight: '3.5rem',
    border: '1px solid silver',
    borderRadius: '0.5rem',
    boxSizing: 'border-box',
    height: 'fit-content',
    maxHeight: '100svh',
    padding: '1rem',
    paddingTop: '0'
  },

  fieldsTitleArea: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '0.5rem',
    paddingTop: '1rem',
    paddingBottom: '0.5rem',
    background: 'white'
  },

  fieldsTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '0.5rem',

    '& > span': {
      textDecoration: 'underline',
      fontSize: theme.size.sm
    },

    '& > button': {
      fontSize: theme.size.sm
    }
  },

  button: {
    width: 'fit-content',
    height: '28px',
    padding: '0 0.75rem'
  },

  fieldsSearch: {
    border: '1px solid silver',
    borderRadius: '0.5rem',
    padding: '0.5rem',
    outline: 'none',
    fontSize: theme.size.sm
  }
}))

export default useStyles
